import Vue from 'vue'
import Vuex from 'vuex'
import boleto from './modules/boleto'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    boleto
  },
  strict: debug,
  plugins: []
})